import {
  assoc,
  evolve,
  identity,
  lensProp,
  not,
  over,
  pipe,
  propSatisfies,
  when,
} from 'ramda';
import { useUpdateCourseInstancesMutation } from '../services/generated/studentPortalApi';
import { CourseInstance, PublishStatus } from '@versita/shared/models';
import { useHandleMutationError } from '@versita/frontend/api-utils';

export const usePublish = () => {
  const [saveCourseInstances, { isLoading: isUpdating }] =
    useHandleMutationError(useUpdateCourseInstancesMutation);
  const toggleWillNotPublish = over(
    lensProp<CourseInstance>('willNotPublish'),
    not,
  );

  function handlePublishStatus(
    selectedCourse: CourseInstance,
    status: PublishStatus,
  ) {
    // Update the condition to allow unlocking
    if (
      selectedCourse.willNotPublish &&
      status !== 'willNotPublish' &&
      selectedCourse.published
    ) {
      return Promise.reject(
        "You can't publish a disabled timetable, please enable it first",
      );
    }

    const updatedCourseInstance = {
      ...selectedCourse,
      published: status === 'published',
      willNotPublish: status === 'willNotPublish',
    };

    return saveCourseInstances({
      body: [updatedCourseInstance],
    });
  }

  function updateSelectedItems(
    selectedInstances: CourseInstance[],
    selectedIds: string[],
    published: boolean | null,
    willNotPublish: boolean,
  ) {
    const updatedInstances = selectedInstances
      .filter(propSatisfies((id) => selectedIds.includes(id), 'id'))
      .map(
        pipe(
          when(() => published !== null, assoc('published', published)),
          when(() => willNotPublish, toggleWillNotPublish),
        ),
      );
    return saveCourseInstances({ body: updatedInstances });
  }
  console.log('LOADING', isUpdating);

  return {
    updateSelectedItems,
    handlePublishStatus,
    isUpdating,
  };
};
